import type { FeedbackToolbarOptions } from '@darwin-launchpad/legacy-shared/feedback-toolbar';
import { getAuthTokensService } from './auth/AuthTokensService';

/** This app's Launchpad id: the runtime-flags probe and the toolbar both use it. */
export const FEEDBACK_TOOLBAR_APP_ID = 'bid-checker';

/**
 * Options for the customer feedback toolbar. It shows only while this lane's
 * `feedback_toolbar` flag is on; the embed is not downloaded until then.
 */
export function feedbackToolbarOptions(): FeedbackToolbarOptions {
  return {
    appId: FEEDBACK_TOOLBAR_APP_ID,
    apiBaseUrl: (import.meta.env.VITE_LAUNCHPAD_API_BASE_URL as string | undefined)?.replace(/\/+$/, ''),
    // Asked on every probe, so a token refreshed by the hidden iframe is picked up.
    getAccessToken: () => getAuthTokensService().getCurrentCredentials()?.access_token?.token,
    load: () => import('@darwin/feedback-embed/customer'),
  };
}
